import { useDispatch, useSelector } from 'react-redux';
import GenericLineChart from '../../Charts/GenericLineChart';
import PerformanceCard from '../PerformanceCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceNewContactsCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import getLineChartYStepValue from '../../utils/getLineChartYStepValue';

export default function NewContacts() {
  const dispatch = useDispatch();
  const {
    loading,
    hasFetched,
    value,
    variation,
    percentage_status,
    icon,
    labels,
    datasets,
  } = useSelector((state) => state.DashboardSlice.newContacts);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceNewContactsCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'newContacts',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard ref={ref} loading={loading || isStale} id="new-contacts">
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'NewContacts')}
      </PerformanceCard.Header>
      <PerformanceCard.Summary
        value={value}
        tendency={variation}
        icon={icon}
        percentageStatus={percentage_status}
      />
      <PerformanceCard.Content>
        <GenericLineChart
          labels={labels}
          datasets={datasets}
          yStepSize={getLineChartYStepValue(datasets[0]?.data)}
          autoSkip
        />
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}
